<form #form="ngForm" (ngSubmit)="form.valid && submit()" novalidate>
    <div class="modal-header">
        <h1 class="modal-title font-size-1-75" id="modal-page-fix-title" translate>
            Use PageCorrect to fix Broken Link
        </h1>
    </div>
    <div class="modal-body bg-white page-fix-form-fix">
        <mon-spinner [loading]="loading">
            <div class="bg-light-grey d-flex align-items-stretch img-rounded mb-3 px-4 py-4">
                <div class="flex-fill">
                    <div class="form-group row">
                        <label class="col-48 control-label" for="page_fix_url" translate>
                            Please insert correct URL:
                        </label>
                        <div class="col-auto flex-fill">
                            <input id="page_fix_url"
                                   class="form-control"
                                   type="text"
                                   pattern="([a-zA-Z]*:)?\/\/.*"
                                   required
                                   [(ngModel)]="linkReplacement"
                                   name="linkReplacement"
                                   #urlInput="ngModel"/>
                            <div class="invalid-feedback block" *ngIf="urlInput.dirty && (urlInput.invalid || urlInput.errors?.['pattern'])">
                                <span translate>URL must start with a protocol. Ex. http://....</span>
                            </div>
                        </div>
                        <div class="col-48 text-right mt-2">
                            <a [href]="linkReplacement"
                               target="_blank" aria-describedby="linkOpensInNewTab"
                               class="fas fa-external-link-alt fa-lg fa-fw"
                               [attr.aria-label]="'Go to predefined url' | translate">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <p class="font-weight-300 font-size-1-3" translate>
                Links written in different ways that lead to the same destination are listed(limited to 5 URLs displayed, but the full number of URLs discovered is also stated below).
                When fixing the link, all  other links that lead to the same destination will also be fixed.
            </p>
            <ul class="list-unstyled">
                <li *ngFor="let url of urls; let i = index" class="text-bold mb-3">
                    <p *ngIf="i < 5" class="label label-info">{{url.url}}</p>
                </li>
            </ul>
        </mon-spinner>
    </div>
    <div class="modal-footer">
        <button data-test="cancel-button" class="btn btn-border-radius btn-secondary" type="button" (click)="cancel()" translate>
            Cancel
        </button>
        <button data-test="save-button" class="btn btn-border-radius btn-marine-blue ml-0" [disabled]="form.invalid" translate>Save</button>
    </div>
</form>
